import * as React from "react";
import type { SVGProps } from "react";
const SvgTrendlIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="trendl_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M789.333 170.667a64 64 0 1 0 0 128 64 64 0 0 0 0-128zm-149.333 64a149.333 149.333 0 1 1 71.808 127.658l-349.44 349.483a149.333 149.333 0 1 1-63.36-57.301l355.499-355.542A148.779 148.779 0 0 1 640 234.667zM170.667 789.333a64 64 0 1 0 128 0 64 64 0 0 0-128 0z"
    />
  </svg>
);
export default SvgTrendlIcon;
